import React, { createContext, useState, useContext } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Constants } from '../constants';
import { Icon } from '@iconify/react/dist/iconify.js';
import ToasterDialogBox from '../components/Dialog/ToasterDialogBox';

export const ImgText = ({ text, sx }) => {
    return (
        <Typography variant="h1" mt={1}
            sx={{
                backgroundImage: `url(${Constants.customImages.TextBgImg})`, 
                backgroundSize: "cover",
                backgroundPosition: "center",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: "bold",
                display: "inline-block",
                ...sx
            }}

        >{text}</Typography>
    )
}

const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
    const [open, setOpen] = useState({ success: false, error: false, warning: false });
    const [heading, setHeading] = useState('');
    const [subHeading, setSubHeading] = useState('');
    const [type, setType] = useState('success');

    const showToaster = (newHeading, newSubHeading, toasterType) => {
        setHeading(newHeading);
        setSubHeading(newSubHeading);
        setType(toasterType);
        setOpen(prev => ({ ...prev, [toasterType]: true }));
    };

    const handleClose = (toasterType) => setOpen(prev => ({ ...prev, [toasterType]: false }));

    return (
        <ToasterContext.Provider value={{ showToaster }}>
            {children}
            {open.success && (
                <ToasterDialogBox open={open.success} handleClose={() => handleClose('success')} width={'40%'} padding={'0 10px 10px 10px'}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', backgroundColor: 'green.100' }}>
                        <img src={Constants.customImages.CompletedImg} alt='Success' width={'40%'} />
                        <ImgText text={heading} sx={{ textAlign: 'center', fontSize: '20px', mt: 1, color: 'green' }} />
                        <Typography variant='body2'  my={2} textAlign={'center'}>
                            {subHeading}
                        </Typography>
                    </Box>
                </ToasterDialogBox>
            )}
            {open.error && (
                <ToasterDialogBox open={open.error} handleClose={() => handleClose('error')} width={'40%'} padding={0} isShowCross={false}>
                    <Box sx={{ bgcolor: "#DC143C", px: 3, py: 5 }}>
                        <Box sx={{ display: "flex", alignItems: 'center', gap: 2 }}><Typography variant='h2' color='#fff'>Error</Typography> <Icon icon="solar:danger-bold" color='#fff' width="30" height="30" /></Box>
                        <Typography variant='body1' color='#fff' mt={2}>{heading}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                        <Button onClick={() => handleClose('error')} style={{border:"0.5px solid #DC143C",backgroundColor:"#FFE2E2",color:"#DC143C"}}>Close</Button>
                    </Box>


                </ToasterDialogBox>
            )}
            {open.warning && (
                <ToasterDialogBox open={open.warning} handleClose={() => handleClose('warning')} width={'35%'} padding={0}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', bgcolor: "#FFC107", height: "150px" }}>
                        <Icon icon="material-symbols:warning-rounded" color='#fff' width="60" height="60" />
                    </Box>
                    <Box px={3} pb={3}>
                        <Typography variant='h4' my={2} textAlign={"center"}>{subHeading}</Typography>
                        <Typography variant='body2' textAlign={"center"}>{heading}</Typography>

                    </Box>

                </ToasterDialogBox>
            )}
        </ToasterContext.Provider>
    );
};

export const useToaster = () => useContext(ToasterContext);